// extracted by mini-css-extract-plugin
export default {"labelGroup":"sliderWithInput_labelGroup__s6etE"};